import React from "react";
import { Fab, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function PATAddButton(props) {
  const { tooltipText, onClick, disabled } = props;

  const button = (
    <Fab
      disabled={disabled || false}
      size="small"
      color="secondary"
      aria-label="add"
      onClick={onClick}
    >
      <AddIcon />
    </Fab>
  );

  return (
    <Tooltip title={tooltipText || "Add"}>
      {disabled ? <span>{button}</span> : button}
    </Tooltip>
  );
}
